// extracted by mini-css-extract-plugin
module.exports = {"banner":"_93444fe79c--banner--ZvHKr","title":"_93444fe79c--title--zlHkQ"};